export default "__VITE_ASSET__$MzTN7rY__"